import { AsyncButton } from 'components/ButtonNew/Button';
import * as React from 'react';

interface ButtonReauthorizationProps {
  isConnected: boolean;
  form: string;
  disable?: boolean;
}

const ButtonReauthorization: React.FunctionComponent<ButtonReauthorizationProps> = ({ isConnected, form, disable }) => {

  if (!isConnected) return null;
  return (
        <>
            <AsyncButton
                form={form}
                type="submit"
                variant='outlined'
                color='inherit'
                disabled={disable}
                style={{ padding: '10px 1rem' }}>Otorisasi Ulang</AsyncButton>
        </>
  );
}

export default ButtonReauthorization;